import { css, SerializedStyles } from '@emotion/react'
import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing } from '@opallabs/gem'
import type { StyleProps } from './types'

export const placeholderDiv = ({ theme }: StyleProps): CSSObject => ({
  float: 'inline-start',
  borderRadius: Size.Rounding * 1.25,
  blockSize: Spacing.S,
  marginBlockStart: Spacing.XS,
  marginInlineEnd: Spacing.XS * 1.25,
  inlineSize: Spacing.XL * 1.5625,
  backgroundColor: Color[theme].Translucent.N02,
})

export const notificationItemStyles = ({
  placeholder,
  theme,
}: StyleProps & {
  placeholder: boolean
}): CSSObject => ({
  backgroundColor: Color[theme].Translucent.N02,
  cursor: 'pointer',
  paddingInline: Spacing.M * 1.25,
  paddingBlockEnd: Spacing.XS * 1.25,
  paddingBlockStart: Spacing.S * 1.25,
  userSelect: 'none',
  marginBlockEnd: Spacing.XS / 2,
  minBlockSize: placeholder ? Spacing.M * 2.75 : '',

  '&:hover': {
    backgroundColor: Color[theme].Translucent.A12,
  },

  button: {
    backgroundColor: Color[theme].Translucent.N08,
    color: Color[theme].Text.Default,

    '&:hover': {
      backgroundColor: Color[theme].Translucent.N12,
    },
  },
})

export const newNotifStyles = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Translucent.A12,
  opacity: 0,
  animation: 'fadeIn 500ms ease 1',
  animationFillMode: 'forwards',

  '&:hover': {
    backgroundColor: Color[theme].Translucent.A24,
  },
})

export const newNotifDelay = (): SerializedStyles => {
  const styles: CSSObject = {}

  for (let i = 1; i <= 20; i += 1) {
    styles[`&:nth-of-type(${i})`] = {
      animationDelay: `${125 * i}ms`,
    }
  }

  return css(styles)
}

export const headerStyles = css({
  display: 'flex',
  flexFlow: 'row nowrap',
})

export const notificationContentStyles = css({
  flex: '1 1 auto',
  paddingInlineEnd: Spacing.S * 1.25,
})

export const closeButtonStyles = ({ theme }: StyleProps): CSSObject => ({
  flex: '0 0 auto',
  opacity: 0.6,
  cursor: 'pointer',
  padding: Spacing.XS * 1.25,
  margin: `-${Spacing.XS * 1.25}px`,
  borderRadius: Size.Rounding,
  border: 'none',
  background: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity 0.2s ease, background-color 0.2s ease',

  '&:hover, &:focus': {
    opacity: 1,
    backgroundColor: Color[theme].Translucent.N06,
  },

  '&:focus': {
    outline: `2px solid ${Color[theme].Text.Accent}`,
    outlineOffset: '2px',
  },

  svg: {
    color: Color[theme].Text.Gray,
  },

  '&:hover svg, &:focus svg': {
    color: Color[theme].Text.Default,
  },
})

export const statusStyles = css({
  flex: '0 0 auto',

  '> *': {
    marginInlineEnd: Spacing.S * 1.25,
    marginBlockStart: Spacing.XS,
  },
})

export const placeHolderRow = css({
  inlineSize: '100%',

  '> *': {
    marginBlockStart: Spacing.XS,

    '&:nth-of-type(1)': {
      inlineSize: '17%',
    },
    '&:nth-of-type(2)': {
      inlineSize: '41%',
    },
    '&:nth-of-type(3)': {
      inlineSize: '28%',
    },
  },
})
